import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isUngatedForWorkingHours", "children"];
import { useCallback, useState } from 'react';
import { usePrompt } from '../hooks/usePrompt';
import { UserPromptType } from '../constants';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useUserPropertyValue } from '../../working-hours/hooks/useUserPropertyValue';
import { HS_STANDARD_TIME_ZONE, HS_WORKING_HOURS } from '../../working-hours/constants';
import { getParsedJsonPropertyValue } from '../../working-hours/records/CrmObject';
import UILink from 'UIComponents/link/UILink';
import { getUserWorkingHoursURL } from '../../working-hours/utils/workingHoursUtils';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useToggledByWorkingHours } from '../hooks/useToggledByWorkingHours';
import { Bold } from '../../shared/components/Bold';
import { jsx as _jsx } from "react/jsx-runtime";
const AgentStatusWorkingHoursPrompt = ({
  userId,
  isAway,
  children
}) => {
  const [wasDismissed, setWasDismissed] = useState(false);
  const {
    promptData,
    dismissPrompt,
    markPromptAsShown
  } = usePrompt(UserPromptType.AGENT_STATUS_WORKING_HOURS);
  const {
    value: userWorkingHours
  } = useUserPropertyValue(userId, HS_WORKING_HOURS, getParsedJsonPropertyValue);
  const {
    value: userTimezone
  } = useUserPropertyValue(userId, HS_STANDARD_TIME_ZONE);
  const {
    wasToggledByWorkingHours
  } = useToggledByWorkingHours({
    isAway,
    userWorkingHours,
    userTimezone
  });
  const isUnseen = promptData && promptData.viewedCount === 0;
  const shouldShowPrompt = isUnseen && wasToggledByWorkingHours && !wasDismissed;
  const handleOpenChange = useCallback(async e => {
    setWasDismissed(!e.target.value);
    await dismissPrompt();
  }, [setWasDismissed, dismissPrompt]);
  return /*#__PURE__*/_jsx(UIPopover, {
    className: "p-2",
    width: 330,
    use: "longform",
    placement: "right",
    open: shouldShowPrompt,
    onOpenComplete: markPromptAsShown,
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.prompts.agentStatusWorkingHoursHeader"
        })
      }),
      body: /*#__PURE__*/_jsx("div", {
        className: "p-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "routing-ui.prompts.agentStatusWorkingHours_jsx",
          elements: {
            UILink,
            Bold
          },
          options: {
            linkProps: {
              href: getUserWorkingHoursURL(userId),
              external: true
            }
          }
        })
      })
    },
    children: children
  });
};
AgentStatusWorkingHoursPrompt.displayName = 'AgentStatusWorkingHoursPrompt';
export const AgentStatusWorkingHoursPromptGated = _ref => {
  let {
      isUngatedForWorkingHours,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return isUngatedForWorkingHours ? /*#__PURE__*/_jsx(AgentStatusWorkingHoursPrompt, Object.assign({}, rest, {
    children: children
  })) : children;
};
AgentStatusWorkingHoursPromptGated.displayName = 'AgentStatusWorkingHoursPromptGated';